import { Matic, Optimism } from '../assets/icons';

export const chainIcons: Record<
  number,
  {
    name: string;
    icon: string;
  }
> = {
  1: {
    name: 'Ethereum',
    icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png',
  },
  11155111: {
    name: 'Sepolia',
    icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png',
  },
  42161: {
    name: 'Arbitrum One',
    icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/info/logo.png',
  },
  421614: {
    name: 'Arbitrum sepolia',
    icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/info/logo.png',
  },
  56: {
    name: 'BSC Mainnet',
    icon: 'https://img.cryptorank.io/coins/bnb1732530324407.png',
  },
  97: {
    name: 'BSC Testnet',
    icon: 'https://img.cryptorank.io/coins/bnb1732530324407.png',
  },
  200810: {
    name: 'Bitlayer Testnet',
    icon: 'https://raw.githubusercontent.com/bitlayer-network/assets/main/bitlayer-logo.png',
  },
  200901: {
    name: 'Bitlayer Mainet',
    icon: 'https://raw.githubusercontent.com/bitlayer-network/assets/main/bitlayer-logo.png',
  },
  6900: {
    name: 'Nibiru',
    icon: 'https://img.cryptorank.io/coins/nibiru1744727629455.png',
  },
  6911: {
    name: 'Nibiru testnet',
    icon: 'https://img.cryptorank.io/coins/nibiru1744727629455.png',
  },
  713715: {
    name: 'Sei devnet',
    icon: 'https://img.cryptorank.io/coins/sei_network1661962346631.png',
  },
  1329: {
    name: 'Sei mainet',
    icon: 'https://img.cryptorank.io/coins/sei_network1661962346631.png',
  },
  43113: {
    name: 'Avalanche testnet',
    icon: 'https://img.cryptorank.io/coins/avalanche1629705441155.png',
  },
  43114: {
    name: 'Avalanche',
    icon: 'https://img.cryptorank.io/coins/avalanche1629705441155.png',
  },
};

export const supportedNetworks = [
  {
    id: 'eth',
    name: 'Ethereum',
    icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png',
  },
  {
    id: 'base',
    name: 'Base',
    icon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/base/info/logo.png',
  },
  {
    id: 'bsc',
    name: 'BNB Chain',
    icon: 'https://img.cryptorank.io/coins/bnb1732530324407.png',
  },
  {
    id: 'arb',
    name: 'Arbitrum',
    icon: 'https://img.cryptorank.io/coins/arbitrum1696871846920.png',
  },
  {
    id: 'avax',
    name: 'Avalanche',
    icon: 'https://img.cryptorank.io/coins/avalanche1629705441155.png',
  },
  {
    id: 'op',
    name: 'Optimism',
    icon: Optimism,
  },
  {
    id: 'pol',
    name: 'Polygon',
    icon: Matic,
  },
  {
    id: 'near',
    name: 'Near',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6535.png',
  },
];
